import PropTypes from "prop-types"
import React, { Component } from "react"

//Simple bar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"
import backIcon from "../../assets/images/rsicons/backIcon.png"
import dealIcon from "../../assets/images/rsicons/deal.png"
import engagementIcon from "../../assets/images/rsicons/engagement.png"
import activity from "../../assets/img/Activity.png"
import seller from "../../assets/img/Seller.png"
import profile from "../../assets/img/Profile.png"
import investor from "../../assets/img/investor.png"
import dashboard from "../../assets/img/Dashboard-new.png"
import buyerImg from "../../assets/img/Buyer.png"
import deleteImg from "../../assets/img/power-on.png"
import dealImg from "../../assets/img/handshake.png"
//i18n
import { withTranslation } from "react-i18next"
import buyer from "pages/Lead/questions/buyer"
import Swal from 'sweetalert2';
import { API_URL } from "helpers/app_url"
import axios from "axios"
import { Card, CardBody } from "reactstrap"
import { hasPermission } from "helpers/checkPermission"
class ClientSidebar extends Component {
  constructor(props) {
    super(props)
    this.refDiv = React.createRef()
  }
  isProfilePath = () => {
    const { location } = this.props;
    const profilePaths = [
      '/clients/profile/primary/',
      '/clients/profile/secondary/',
      '/clients/profile/faimily-info/',
       '/clients/profile/important-date/'
    ];
   
    return profilePaths.some(path => 
      location.pathname.includes(path + this.props.match.params.id + "/" + this.props.match.params.clientId)
    );
  }
  isActivityPath = () => {
    const { location } = this.props;
    const activityPaths = [
      '/clients/activity/appointment/',
      '/clients/activity/documents/',
      '/clients/activity/message/',
       '/clients/activity/note/'
    ];
   
    return activityPaths.some(path => 
      location.pathname.includes(path + this.props.match.params.id + "/" + this.props.match.params.clientId)
    );
  }

  isDealPath = () => {
    const { location } = this.props;
    const dealPaths = [
      '/clients/activity/engagement/',
      '/clients/activity/deal/'
    ];
    return dealPaths.some(path => 
      location.pathname.includes(path + this.props.match.params.id + "/" + this.props.match.params.clientId)
    );
  }


  isSellerPath = () => {
    const { location } = this.props;
    const sellerPaths = [
      '/clients/seller/property/',
      '/clients/seller/showings/',
      '/clients/seller/open-house/',
      '/clients/seller/questions/',
      '/clients/seller/checklists/'
    ];
    return sellerPaths.some(path => 
      location.pathname.includes(path + this.props.match.params.id + "/" + this.props.match.params.clientId)
    );
  }

  isBuyerPath = () => {
    const { location } = this.props;
    const buyerPaths = [
      '/clients/buyer/listings/',
      '/clients/buyer/preferences/',
      '/clients/buyer/questions/',
      '/clients/buyer/checklists/'
    ];
    return buyerPaths.some(path => 
      location.pathname.includes(path + this.props.match.params.id + "/" + this.props.match.params.clientId)
    );
  }

  isInvestorPath = () => {
    const { location } = this.props;
    const investorPaths = [
      '/clients/investor/investments/',
      '/clients/investor/questions/'
    ];
    return investorPaths.some(path => 
      location.pathname.includes(path + this.props.match.params.id + "/" + this.props.match.params.clientId)
    );
  }
  
isActive(path) {
  return this.props.location?.pathname === path ? "active" : "";
}

  render() {
    const userModule = localStorage.getItem('userModule');
    const isActivityActive = this.isActivityPath();
    const isDealActive = this.isDealPath();
    const isSellerActive = this.isSellerPath();
    const isBuyerActive = this.isBuyerPath();
    const isInvestorActive = this.isInvestorPath();
    const isProfileActive = this.isProfilePath();
    const {clientDetail, isResponsive} = this.props;
   

const { id, clientId } = this.props.match.params;

const menuItems = [
  { link: `/clients`, icon: backIcon, label: "Back" },
  { link: `/clients/dashbord/${id}/${clientId}`, icon: dashboard, label: "Dashboard" },
  { link: `/clients/profile/primary/${id}/${clientId}`, icon: profile, label: "Profile" },
  { link: `/clients/activity/deal/${id}/${clientId}`, icon: dealImg, label: "Deals" },
  { link: `/clients/activity/appointment/${id}/${clientId}`, icon: activity, label: "Activity" },
];

// ✅ Inject Buyer/Seller/Investor Options
if (clientDetail.clientTypes && clientDetail.clientTypes.length > 0) {
  clientDetail.clientTypes.forEach((type) => {
    switch (type.clientTypeCode) {
      case 1:
        menuItems.push({ link: `/clients/buyer/listings/${id}/${clientId}`, icon: buyerImg, label: "Buyer" });
        break;
      case 2:
        menuItems.push({ link: `/clients/seller/property/${id}/${clientId}`, icon: seller, label: "Seller" });
        break;
      case 4:
        menuItems.push({ link: `/clients/investor/investments/${id}/${clientId}`, icon: investor, label: "Pre-Construction" });
        break;
      default:
        break;
    }
  });
}
menuItems.push({ link: `/clients/profile/active/${id}/${clientId}`, icon: deleteImg, label: "Manage" });

    return (
      <React.Fragment>
        {isResponsive ? (
          <div className="d-flex align-items-center position-relative" style={{ overflow: "hidden" }}>
    
    {/* Left Scroll Button */}
    <button
      className="btn btn-light position-absolute start-0 z-3"
      style={{  borderRadius: 0 }}
      onClick={() => this.tabContainer.scrollLeft -= 120}
    >
      ‹
    </button>

    {/* Scrollable Tabs */}
    <div
      className="d-flex overflow-auto py-2 px-4"
      style={{ whiteSpace: "nowrap", gap: "10px", scrollBehavior: "smooth" }}
      ref={(el) => (this.tabContainer = el)}
    >
      {menuItems.map((item, index) => (
        <Link
          key={index}
          to={item.link}
          className={`btn mx-1 d-flex align-items-center ${this.isActive(item.link) ? "btn-active" : "btn-outline-secondary"}`}
          style={{ flexShrink: 0 }}
        >
          <img src={item.icon} height="20px" className="me-2" />
          {item.label}
        </Link>
      ))}
    </div>

    {/* Right Scroll Button */}
    <button
      className="btn btn-light position-absolute end-0 z-3"
      style={{  borderRadius: 0 }}
      onClick={() => this.tabContainer.scrollLeft += 120}
    >
      ›
    </button>

            </div>
           
        ):(
            <SimpleBar className="h-100 project-bar" ref={this.refDiv}>
          <div id="sidebar-menu" className="setting-menu">
           
            <ul className="metismenu list-unstyled" id="side-menu">
            <li>
                <Link to={"/clients" }  className="  ">
                <img src={backIcon}  width='16px' className="mdi mdi-home-import-outline ms-1"/>
                </Link>
              </li>
            
               <li><Link  to={"/clients/dashbord/" + this.props.match.params.id + "/" + this.props.match.params.clientId}  className=" project-link">
               <img src={dashboard} height="24px" style={{marginRight:10, verticalAlign:'middle'}} />
                 <span>{this.props.t("Dashboard")}</span></Link>
                </li>
              {hasPermission("RealtorClients", "View") && (
                <li className="mm-data">
                <Link to={"/clients/profile/primary/" + this.props.match.params.id + "/" + this.props.match.params.clientId}  className={isProfileActive ? "project-link active" : "project-link"}>
                <img src={profile} height="24px" style={{marginRight:10, verticalAlign:'middle'}} />
                  <span>{this.props.t("Profile")}</span>
                </Link>
              
              </li>
                    )}
              <li className="mm-data">
                <Link to={"/clients/activity/deal/" + this.props.match.params.id + "/" + this.props.match.params.clientId}  className={isDealActive ? "project-link active" : "project-link"}>
                <img src={dealImg} height="24px" style={{marginRight:10, verticalAlign:'middle'}} />
                  <span>{this.props.t("Deals")}</span>
                </Link>
              </li>
              <li className="mm-data">
                <Link to={"/clients/activity/appointment/" + this.props.match.params.id + "/" + this.props.match.params.clientId} className={isActivityActive ? "project-link active" : "project-link"}>
                <img src={activity} height="24px" style={{marginRight:10, verticalAlign:'middle'}} />
                  <span>{this.props.t("Activity")}</span>
                </Link>
               
              </li>
              
              {clientDetail.clientTypes && clientDetail.clientTypes.length > 0 ? (
               clientDetail.clientTypes.map((type) => {
              switch (type.clientTypeCode) {
                case 1: // Buyer
                  return (
                    <li className="mm-data" key={type.id}>
                      <Link
                        to={"/clients/buyer/listings/" + this.props.match.params.id + "/" + this.props.match.params.clientId}
                        className={isBuyerActive ? "project-link active" : "project-link"}
                      >
                        <img src={buyerImg} height="24px" style={{ marginRight: 10, verticalAlign: 'middle' }} />
                        <span>{this.props.t("Buyer")}</span>
                      </Link>
                    </li>
                  );
                case 2: // Seller
                  return (
                    <li className="mm-data" key={type.id}>
                      <Link
                        to={"/clients/seller/property/" + this.props.match.params.id + "/" + this.props.match.params.clientId}
                        className={isSellerActive ? "project-link active" : "project-link"}
                      >
                        <img src={seller} height="24px" style={{ marginRight: 10, verticalAlign: 'middle' }} />
                        <span>{this.props.t("Seller")}</span>
                      </Link>
                    </li>
                  );
                case 4: 
                  return (
                    <li className="mm-data" key={type.id}>
                      <Link
                        to={
                          "/clients/investor/investments/" +
                          this.props.match.params.id +
                          "/" +
                          this.props.match.params.clientId
                        }
                        className={isInvestorActive ? "project-link active" : "project-link"}
                      >
                        <img src={investor} height="24px" style={{ marginRight: 10, verticalAlign: 'middle' }} />
                        <span>{this.props.t("Pre-Construction")}</span>
                      </Link>
                    </li>
                  );
                default:
                  return null;
                }
              })
            ) : (
              <></>
            )}
           <li className="mm-data">
                <Link to={"/clients/profile/active/"+ this.props.match.params.id + "/" + this.props.match.params.clientId} className="project-link">
                <img src={deleteImg} height="24px" style={{marginRight:10, verticalAlign:'middle'}} />
                  <span>{this.props.t("Manage")}</span>
                </Link>
                
                
              </li>
        

             
            
            </ul>
          </div>
        </SimpleBar>
        )}
      
       
      </React.Fragment>
    )
  }
}

ClientSidebar.propTypes = {
  location: PropTypes.object,
  history:PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
  match:PropTypes.object,
  clientDetail:PropTypes.object,
  isResponsive:PropTypes.object
}

export default withRouter(withTranslation()(ClientSidebar))
